import { Component, Input } from '@angular/core';
import { CategoryColorVariant } from '../../models';

/**
 * Category Badge Component
 * 
 * Displays a colored pill badge for agent categories.
 * Uses design system color variables for consistent theming.
 * 
 * Features:
 * - Multiple color variants: blue, green, orange, purple
 * - Pill-shaped design with rounded corners
 * - Consistent sizing and typography
 * 
 * Usage:
 * <app-category-badge
 *   [category]="'Regulations'"
 *   [colorVariant]="'blue'">
 * </app-category-badge>
 */
@Component({
  selector: 'app-category-badge',
  templateUrl: './category-badge.component.html',
  styleUrls: ['./category-badge.component.scss']
})
export class CategoryBadgeComponent {
  /**
   * Category name to display in the badge
   */
  @Input() category: string = '';

  /**
   * Color variant for the badge styling
   * Maps to design system color variables
   */
  @Input() colorVariant: CategoryColorVariant = 'blue';

  /**
   * Get CSS class based on color variant
   * 
   * @returns string - CSS class name for the variant
   */
  get variantClass(): string {
    return `badge-${this.colorVariant}`;
  }
}
